let state = {
    commentDate: [], // 有评价的所有日期
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/habitJournal/state.js